import styled from "styled-components";

export const WrapInput = styled.div`
width: 100%;
height: auto;
display: flex;
justify-content: center;
align-items: center;
margin-top: 80px;
`